import React from 'react';
import { compose } from 'ramda';
import { makeStyles } from '@material-ui/core';
import {
  reduxForm,
  Form,
  Field,
  InjectedFormProps,
  getFormValues,
  isValid
} from 'redux-form';
import Fields from 'components/Fields';
import { Button, BoxWrapper } from 'components/Base';
import { CustomerType } from 'store/modules/Customers/types';
import { MetaType } from 'store/modules/Meta/types';
import Store from 'store/store';

const useStyles = makeStyles({
  paper: {
    minWidth: '20rem'
  },
  form: {
    padding: '1rem'
  },
  hidden: {
    visibility: 'hidden'
  },
  title: {
    marginBottom: '2rem'
  },
  btnBox: {
    marginTop: '2rem',
    display: 'flex',
    justifyContent: 'space-between'
  },
  field: {
    margin: '1rem 0'
  }
});

const { connect, selectors } = Store;

interface NewPolicyModalProps {
  customers: Array<CustomerType>;
  policyTypes: MetaType;
  values: any;
  isValid: boolean;
}

const NewPolicyModal = ({
  handleSubmit,
  customers,
  policyTypes,
  values,
  isValid,
  submitting
}: InjectedFormProps & NewPolicyModalProps) => {
  const classes = useStyles();

  return (
    <BoxWrapper
      className={classes.paper}
      title="New policy"
      closeModal={values.closeModalFunc}
    >
      <Form onSubmit={handleSubmit} className={classes.form}>
        <Field
          name={`owner`}
          fullWidth
          className={classes.field}
          validate={Fields.Validators.required}
          displayEmpty
          options={customers.map((customer: CustomerType) => {
            return {
              name: customer.display_name,
              value: customer.id
            };
          })}
          component={Fields.String}
          label="Policy owner(s)"
        />
        <Field
          name={`type`}
          fullWidth
          validate={Fields.Validators.required}
          displayEmpty
          className={classes.field}
          options={policyTypes}
          component={Fields.Select}
          label="Policy type"
        />

        <div className={classes.btnBox}>
          <Button
            style={{
              width: '45%'
            }}
            onClick={values.closeModalFunc}
          >
            Cancel
          </Button>
          <Button
            style={{
              width: '45%'
            }}
            disabled={!isValid}
            isLoading={submitting}
            color="primary"
            type="submit"
          >
            Create
          </Button>
        </div>
      </Form>
    </BoxWrapper>
  );
};

export default compose(
  reduxForm({
    form: 'newRecommendedPolicy'
  }),
  connect((state: any) => ({
    customers: selectors.customersSelectors.customers(state),
    policyTypes: selectors.metaSelectors.policyTypesRecommended(state),
    values: getFormValues('newRecommendedPolicy')(state),
    isValid: isValid('newRecommendedPolicy')(state)
  }))
)(NewPolicyModal);
